import { render, staticRenderFns } from "./LocalizedString.vue?vue&type=template&id=8dc7918a"
import script from "./LocalizedString.vue?vue&type=script&lang=js"
export * from "./LocalizedString.vue?vue&type=script&lang=js"
import style0 from "./LocalizedString.vue?vue&type=style&index=0&id=8dc7918a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports